import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import App from 'App';
import '../sass/myparkd.sass';
import messages from 'string-translations/translations';
import GlobalErrorBoundaryAppLevel from 'components/GlobalErrorBoundaryAppLevel';
import * as Sentry from '@sentry/react';
import { ReduxState } from 'types';
import CurrentLocale from './CurrentLocale';
import { createTheme, ThemeProvider } from '@mui/material';


const IntlProviderWrapper = (props: any) => {
    let locale = props.userLocale || props.userLanguage; // todo: use browser location with reverse geocoding api?
    let shortLocale = locale.substr(0, 2);

    const theme = createTheme({
        typography: {
            fontFamily: `'sofia-pro', sans-serif`
        }
    });

    return (
        <GlobalErrorBoundaryAppLevel>
            <IntlProvider
                locale={shortLocale}
                messages={messages[locale]}
                onError={(error: any) => { console.error(error); Sentry.captureException(error) }}
            >
                <CurrentLocale>
                    <ThemeProvider theme={theme}>
                        <App />
                    </ThemeProvider>
                </CurrentLocale>
            </IntlProvider>
        </GlobalErrorBoundaryAppLevel>
    );
};

function mapStateToProps(state: ReduxState) {
    return {
        userLocale: state?.user?.user?.locale, // from user object
        userLanguage: state?.userLanguage?.userLanguage, // used when not loggedIn
    };
}

export default connect(mapStateToProps, null)(IntlProviderWrapper);